import * as actions from "./assets.actions";
import * as mutations from "./assets.mutations";
import * as getters from "./assets.getters";
import state from "./assets.state";
// make our modules namespaced to avoid method name conflicts
const namespaced = true;

const assets = {
  namespaced,
  getters,
  mutations,
  actions,
  state
};

export default assets;
